import Enum from '../enum'

/**
 * 枚举类：订单状态
 * OrderStatusEnum
 */
export default new Enum([
  { key: 'PENDING', name: '待付款', value: 1 },
  { key: 'NOT_DELIVERED', name: '待发货', value: 2 },
  { key: 'NOT_RECEIVED', name: '待收货', value: 3 },
  { key: 'COMPLETED', name: '已完成', value: 4 },
  { key: 'USER_CANCEL', name: '用户取消', value: 5 },
  { key: 'SYSTEM_CANCEL', name: '系统取消', value: 6 }
])
